((Drupal, once) => {
  'use strict';

  Drupal.behaviors.mediaSizer = {
    attach(context) {
      const list_ideas = once('mediaSizer', '.wlist_ideas', context)[0];

      if (!list_ideas) return;
      const sizes = new Map();
      const resizeObs = new ResizeObserver((entries) => {
        for (const entry of entries) {
          sizes.set(entry.target, entry.contentRect.height);
        }

        const maxHeight = Math.max(...sizes.values());

        list_ideas.style.setProperty('--media-max-height', `${maxHeight}px`);
      });
      const ideaWMedias = once('mediaSizer', '.field-group-link', context);
      for (const ideaWMedia of ideaWMedias) {
        sizes.set(ideaWMedia, 0);
        resizeObs.observe(ideaWMedia);
      }
    },
  };
})(Drupal, once);
